import { Box } from '@mui/material';
import SectionLoader from 'components/shared/SectionLoader';
import { Contact } from 'model/contacts.model';
import ContactCard from './ContactCard/ContactCard';
import EmptyGrid from './EmptyGrid';
import { muiStyles } from './muiStyles';

const ContactsGrid = ({
  onViewDetails,
  data,
  onDelete,
  onEdit,
  variant = 'default',
  onRefetch,
  isLoading = false,
}: {
  onViewDetails?: (contact: Contact) => void;
  data: Contact[];
  onDelete?: (contact: any, alertText: any) => void;
  onEdit?: (contact: any) => void;
  variant?: 'default' | 'business';
  onRefetch?: () => void | Promise<void>;
  isLoading?: boolean;
}) => {
  if (isLoading) {
    return <SectionLoader />;
  }

  if (data.length === 0) {
    return <EmptyGrid variant={variant} />;
  }

  return (
    <Box sx={muiStyles.gridContainer}>
      {data.map((contact) => (
        <ContactCard
          key={contact.contactId}
          variant={variant}
          onRefetch={onRefetch}
          onViewDetails={onViewDetails}
          contact={contact}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      ))}
    </Box>
  );
};

export default ContactsGrid;
